<template>
  <div class="search-form">
    <el-tabs v-model="tabIndex" @tab-click="handleTabChange">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.label"
        :name="item.name"
      ></el-tab-pane>
    </el-tabs>
    <div class="flex flex-line">
      <template v-if="tabIndex === tabList[0].name">
        <div class="mr10">订单号</div>
        <div class="mr10" style="width:400px;">
          <el-input :value="orderNos" @input="handleInput" clearable :placeholder="inputTips" />
        </div>
        <el-button type="primary" @click="openNosDialog" class="search-btn"
          >选择单号</el-button
        >
        <el-button type="primary" @click="handleStart" class="search-btn"
          >{{ lastBtnText }}</el-button
        >
      </template>
      <template v-else>
        <div>
          <el-upload
            action="no"
            ref="upload"
            :file-list="fileList"
            :http-request="handleUploadFile"
            :auto-upload="false"
            :limit="1"
            :headers="headers"
            :on-change="handleChangeFile"
            :on-exceed="handleExceed"
            :accept="fileTypes.toString()"
          >
            <el-button slot="trigger" class="search-btn"
              ><span class="el-icon-upload2"></span> 上传文件</el-button
            >
            <el-button
              type="primary"
              @click="submitUpload"
              class="search-btn"
              style="margin-left: 8px"
              >{{ lastBtnText }}</el-button
            >
          </el-upload>
        </div>
      </template>
    </div>
    <use-info-text :useInfo="useInfo.list"/>
    <seq-order-dialog ref="dialog" @update="updateSelection" />
  </div>
</template>

<script>

import _ from "lodash";
import UseInfoText from './UseInfoText.vue';
import SeqOrderDialog from './SeqOrderDialog.vue';
export default {
  components: {
    SeqOrderDialog,
    UseInfoText
  },
  props: {
    inputTips: {
      default: '多个订单号,请用英文状态下的分号";"隔开',
      type: String,
    },
    lastBtnText: String,
    orderNos: String,
    tabList: Array,
    useInfo: Object,
  },
  data() {
    return {
      tabIndex: "",
      headers: {},
      fileList: [],
      userInfo: null,
      visible: false,
      maxSize: 500,
      fileTypes:[".rar", ".zip", ".ab1"],
      formData: null
    };
  },
  created() {
    this.userInfo = this.baseMethods.getLocalObj("userInfo");
    this.headers.Authorization = `Bearer ${this.userInfo.token}`;
    this.tabIndex = this.tabList[0].name;
  },
  methods: {
    handleInput(val){
      this.$emit("update:orderNos", val)
    },
    updateSelection(newNos) {
      let oldNos = [];
      if (this.orderNos) {
        oldNos = _.cloneDeep(this.orderNos).split(";");
      }

      this.$emit("update:orderNos", _.union(oldNos, newNos).join(";"));
    },
    handleTabChange(val) {
      this.$emit("clear");
    },
    handleChangeFile(file,fileList) {
      let state = true
      if(file){
        console.log(file)
        let type = file.name.split(".").pop()
        let upload = this.fileTypes.includes("." + _.toLower(type));
        if(!upload) {
          this.$message.error(`文件格式有误，仅支持${this.fileTypes.join("、")}格式`);
          state = false
        }
        let max = this.maxSize >= file.size / 1024 / 1024;
        console.log(this.maxSize , file.size / 1024 / 1024)
        if(upload && !max){
          this.$message.error(`文件大小有误，不能超过${this.maxSize}MB`);
          state = false
        }
        if(!state){
          let list = fileList.filter((item)=> item.uid !== file.uid)
          this.$refs.upload.uploadFiles = list
        }
      }
    },
    async submitUpload() {
      this.formData = new FormData()
      if (!this.$refs.upload.uploadFiles.length) return this.$message.warning("请上传文件");
      await this.$refs.upload.submit();
    },
    openNosDialog() {
      this.$refs.dialog.open()
    },
    handleStart() {
      if (!this.orderNos) return this.$message.warning("请填写订单号");
      this.$emit("start");
    },
    handleUploadFile(action) {
      this.formData.append("file", action.file)
      this.$emit("upload", this.formData,(result)=>{
        console.log("success",this.$refs.upload)
        if(result){
          action.onSuccess(action.file)
        }
      });
    },
    handleExceed(file){
      this.$nextTick(async ()=>{
        this.$refs.upload.clearFiles();
        await this.$refs.upload.handleStart(file[0]);
      })
      
    },
  },
};
</script>
<style lang="scss" scope>
@import url("../../../assets/tools.css");
.flex-line {
  line-height: 40px;
  .search-btn {
    height: 40px;
  }
}
.gray-tips {
  color: #aaaaaa;
  font-size: 12px;
  margin-top: 5px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/tools/component/SeqTopSearch.vue